module.exports = __webpack_public_path__ + "static/media/capa_fachada.14887bb8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/fotos/Fachada/capa_fachada.jpg
// module id = 322
// module chunks = 0